// React
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import {
  Nav,
  Modal,
  Alert,
  NavItem,
  NavLink,
  TabPane,
  ModalBody,
  CardHeader,
  CardFooter,
  TabContent,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';

// Components
import { Checkbox } from './checkbox';
import { ListProposals } from './ListProposals';
import { makeColumnsCardAssociates } from './columnsCardAssociates';

import AOS from 'aos';
import 'aos/dist/aos.css';

export const ModalProposals = ({
  api,
  toggle,
  isOpen,
  customer,
  handleCardDependent,
  handleGenerateReport,
}) => {
  const [activeTab, setActiveTab] = useState('1');
  const [proposalId, setProposalId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dependentsTabData, setDependentsTabData] = useState([]);
  const [dependentsTabName, setDependentsTabName] = useState('');
  const [proposalsAssociates, setProposalsAssociates] = useState(null);

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const makeModalHeader = () => {
    if (activeTab === '1') {
      return <p>Propostas de {customer.name}</p>;
    } else {
      return <p>Dependentes de {customer.name}</p>;
    }
  };

  const getProposalsAssociates = async (hash) => {
    /* This module exclusively needs the `status=active` parameter */
    const proposals = await api.get(`/proposal?customer=${hash}&status=active`);

    if (proposals) {
      setProposalsAssociates(proposals);
      setProposalId(proposals.data[0]?.id);
      setDependentsTabName(proposals.data[0]?.number);
      setDependentsTabData(proposals.data[0]?.dependents);
    }
  };

  const handleViewDependentsTab = (dependents, proposalNumber, proposalId) => {
    setDependentsTabName(proposalNumber);
    setDependentsTabData(dependents);
    setProposalId(proposalId);
    setActiveTab('2');
  };

  useEffect(() => {
    if (customer.hashid) {
      getProposalsAssociates(customer.hashid);
    }
  }, [customer]);

  useEffect(() => {
    AOS.init({
      easing: 'fade-down',
      duration: 1000,
      anchorPlacement: 'top-bottom',
    });
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      size="xl"
      centered
    >
      <ModalHeader>{makeModalHeader()}</ModalHeader>

      <CardHeader>
        <Nav
          className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
          role="tablist"
        >
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' })}
              onClick={() => {
                tabChange('1');
              }}
              style={{ cursor: 'pointer' }}
            >
              <i className="fas fa-home"></i>
              Propostas
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '2' })}
              onClick={() => {
                tabChange('2');
              }}
              style={{ cursor: 'pointer' }}
            >
              <i className="fas fa-home"></i>
              {`Dependentes - Proposta ${dependentsTabName}`}
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={'1'}>
          <ModalBody className="pb-0">
            <ListProposals
              idCustomer={customer.hashid}
              proposalsAssociates={proposalsAssociates}
              handleCardDependent={handleCardDependent}
              handleGenerateReport={handleGenerateReport}
              handleViewDependentsTab={handleViewDependentsTab}
            />
          </ModalBody>
        </TabPane>
        <TabPane tabId={'2'}>
          <ModalBody className="pb-0">
            {selectedRows.length > 0 && (
              <div data-aos="fade-down" data-aos-duration="1000">
                <Alert color="primary" className="border-0 border-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>
                      {selectedRows.length} {selectedRows.length === 1 ? 'dependente' : 'dependentes'} selecionado(s)
                      </strong>
                    </div>

                    <div>
                      <button
                        type="button"
                        className="btn btn-soft-success btn-sm"
                        onClick={() => {
                          handleGenerateReport({
                            proposal_id: proposalId,
                            dependents: selectedRows,
                          });
                        }}
                      >
                        Imprimir Cartão do Titular
                        <i className="ri-arrow-right-line align-middle mx-2"></i>
                      </button>
                    </div>
                  </div>
                </Alert>
              </div>
            )}
            <div>
              <b>
                <p className="fs-5 font-weight-bold">Dependentes</p>
              </b>
              <div>
                <DataTable
                  columns={makeColumnsCardAssociates({
                    handleCardDependent,
                    proposalsAssociates,
                  })}
                  data={dependentsTabData || []}
                  actions={''}
                  pagination
                  persistTableHead
                  perPage={5}
                  isSearchRemote={false}
                  noDataComponent={
                    <>
                      <div className="d-flex justify-content-center">
                        <div>
                          <div className="d-flex justify-content-center mb-1">
                            <h6 className="text-center mt-3">
                              Sem dependentes cadastrados
                            </h6>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  selectableRows
                  onSelectedRowsChange={(state) => {
                    const selectedCustomerIds = state.selectedRows.map(
                      (obj) => obj.customer_id
                    );
                    setSelectedRows(selectedCustomerIds);
                  }}
                  selectableRowsComponent={Checkbox}
                ></DataTable>
              </div>
            </div>
          </ModalBody>
          <CardFooter className="p-0 mt-0"></CardFooter>
        </TabPane>
      </TabContent>
      <ModalFooter>
        <div className="hstack gap-2 justify-content-end ">
          <Link
            to="#"
            className="btn btn-primary mt-3"
            onClick={() => {
              toggle();
              setSelectedRows([]);
            }}
          >
            Fechar
          </Link>
        </div>
      </ModalFooter>
    </Modal>
  );
};
